// extracted by mini-css-extract-plugin
export default {"footer":"footer__OWQ3Y","isPostAuthNav3":"isPostAuthNav3__NGYwM","postAuthNav3PageWrapper":"postAuthNav3PageWrapper__YjFlN"};